module.exports = __webpack_public_path__ + "img/logo-school-10.2a907015.png";